/* eslint-disable import/no-anonymous-default-export */
import LocalStorageItem from './LocalStorageItem';

export default {
  accessToken: new LocalStorageItem<string>({ key: 'accessToken' }),
  refreshToken: new LocalStorageItem<string>({ key: 'refreshToken' }),
};
